import BaseApi from '@/core/HttpResources/BaseApi';

export default class CountryService {
    
    baseApiRol = new BaseApi("Country");
  
    async getDefault(): Promise<any> {
        return new Promise<any>((resolve, reject) => this.baseApiRol.request('GET', 'default', null, {}, (response) => resolve(response.data), reject, () => { }))
    }

  
}